export default "__VITE_ASSET__hHxroKzI__"